// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class FlattenedServiceLogResponse implements flatbuffers.IUnpackableObject<FlattenedServiceLogResponseT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): FlattenedServiceLogResponse {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsFlattenedServiceLogResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: FlattenedServiceLogResponse,
  ): FlattenedServiceLogResponse {
    return (obj || new FlattenedServiceLogResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsFlattenedServiceLogResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: FlattenedServiceLogResponse,
  ): FlattenedServiceLogResponse {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new FlattenedServiceLogResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  liftName(): string;
  liftName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  liftName(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  date(): string;
  date(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  date(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  mode(): string;
  mode(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  mode(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  start(): string;
  start(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  start(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  end(): string;
  end(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  end(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  duration(): string;
  duration(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  duration(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  liftId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  static startFlattenedServiceLogResponse(builder: flatbuffers.Builder) {
    builder.startObject(7);
  }

  static addLiftName(builder: flatbuffers.Builder, liftNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, liftNameOffset, 0);
  }

  static addDate(builder: flatbuffers.Builder, dateOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, dateOffset, 0);
  }

  static addMode(builder: flatbuffers.Builder, modeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, modeOffset, 0);
  }

  static addStart(builder: flatbuffers.Builder, startOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, startOffset, 0);
  }

  static addEnd(builder: flatbuffers.Builder, endOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, endOffset, 0);
  }

  static addDuration(builder: flatbuffers.Builder, durationOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, durationOffset, 0);
  }

  static addLiftId(builder: flatbuffers.Builder, liftId: number) {
    builder.addFieldInt16(6, liftId, 0);
  }

  static endFlattenedServiceLogResponse(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // lift_name
    builder.requiredField(offset, 6); // date
    builder.requiredField(offset, 8); // mode
    builder.requiredField(offset, 10); // start
    builder.requiredField(offset, 12); // end
    builder.requiredField(offset, 14); // duration
    return offset;
  }

  static createFlattenedServiceLogResponse(
    builder: flatbuffers.Builder,
    liftNameOffset: flatbuffers.Offset,
    dateOffset: flatbuffers.Offset,
    modeOffset: flatbuffers.Offset,
    startOffset: flatbuffers.Offset,
    endOffset: flatbuffers.Offset,
    durationOffset: flatbuffers.Offset,
    liftId: number,
  ): flatbuffers.Offset {
    FlattenedServiceLogResponse.startFlattenedServiceLogResponse(builder);
    FlattenedServiceLogResponse.addLiftName(builder, liftNameOffset);
    FlattenedServiceLogResponse.addDate(builder, dateOffset);
    FlattenedServiceLogResponse.addMode(builder, modeOffset);
    FlattenedServiceLogResponse.addStart(builder, startOffset);
    FlattenedServiceLogResponse.addEnd(builder, endOffset);
    FlattenedServiceLogResponse.addDuration(builder, durationOffset);
    FlattenedServiceLogResponse.addLiftId(builder, liftId);
    return FlattenedServiceLogResponse.endFlattenedServiceLogResponse(builder);
  }

  unpack(): FlattenedServiceLogResponseT {
    return new FlattenedServiceLogResponseT(
      this.liftName(),
      this.date(),
      this.mode(),
      this.start(),
      this.end(),
      this.duration(),
      this.liftId(),
    );
  }

  unpackTo(_o: FlattenedServiceLogResponseT): void {
    _o.liftName = this.liftName();
    _o.date = this.date();
    _o.mode = this.mode();
    _o.start = this.start();
    _o.end = this.end();
    _o.duration = this.duration();
    _o.liftId = this.liftId();
  }

  unpackFields(...fields: string[]): FlattenedServiceLogResponseT {
    const t = new FlattenedServiceLogResponseT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("lift_name")) {
      t.liftName = this.liftName();
    }
    if (fieldSet.has("date")) {
      t.date = this.date();
    }
    if (fieldSet.has("mode")) {
      t.mode = this.mode();
    }
    if (fieldSet.has("start")) {
      t.start = this.start();
    }
    if (fieldSet.has("end")) {
      t.end = this.end();
    }
    if (fieldSet.has("duration")) {
      t.duration = this.duration();
    }
    if (fieldSet.has("lift_id")) {
      t.liftId = this.liftId();
    }
    return t;
  }
}

export class FlattenedServiceLogResponseT implements flatbuffers.IGeneratedObject {
  constructor(
    public liftName: string | Uint8Array | null = null,
    public date: string | Uint8Array | null = null,
    public mode: string | Uint8Array | null = null,
    public start: string | Uint8Array | null = null,
    public end: string | Uint8Array | null = null,
    public duration: string | Uint8Array | null = null,
    public liftId: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.liftName === null || this.liftName === undefined) {
      throw new Error('Required field "lift_name" is not set');
    }
    if (this.date === null || this.date === undefined) {
      throw new Error('Required field "date" is not set');
    }
    if (this.mode === null || this.mode === undefined) {
      throw new Error('Required field "mode" is not set');
    }
    if (this.start === null || this.start === undefined) {
      throw new Error('Required field "start" is not set');
    }
    if (this.end === null || this.end === undefined) {
      throw new Error('Required field "end" is not set');
    }
    if (this.duration === null || this.duration === undefined) {
      throw new Error('Required field "duration" is not set');
    }
    const liftName = this.liftName !== null ? builder.createString(this.liftName!) : 0;
    const date = this.date !== null ? builder.createString(this.date!) : 0;
    const mode = this.mode !== null ? builder.createString(this.mode!) : 0;
    const start = this.start !== null ? builder.createString(this.start!) : 0;
    const end = this.end !== null ? builder.createString(this.end!) : 0;
    const duration = this.duration !== null ? builder.createString(this.duration!) : 0;

    return FlattenedServiceLogResponse.createFlattenedServiceLogResponse(
      builder,
      liftName,
      date,
      mode,
      start,
      end,
      duration,
      this.liftId,
    );
  }

  clone(): FlattenedServiceLogResponseT {
    const obj = new FlattenedServiceLogResponseT();
    obj.liftName = this.liftName;
    obj.date = this.date;
    obj.mode = this.mode;
    obj.start = this.start;
    obj.end = this.end;
    obj.duration = this.duration;
    obj.liftId = this.liftId;
    return obj;
  }

  equals(other: FlattenedServiceLogResponseT): boolean {
    if (this.liftName !== other.liftName) return false;
    if (this.date !== other.date) return false;
    if (this.mode !== other.mode) return false;
    if (this.start !== other.start) return false;
    if (this.end !== other.end) return false;
    if (this.duration !== other.duration) return false;
    if (this.liftId !== other.liftId) return false;
    return true;
  }
}

export function verifyFlattenedServiceLogResponse(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "lift_name");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "date");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "mode");
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 10, "start");
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 12, "end");
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 14, "duration");
    verifier.checkScalarField(tablePos, 16, 2);
  } finally {
    verifier.popDepth();
  }
}
